<div class="container mt-3">
    <router-outlet/>
</div>
